import { FormattedMessage } from "react-intl";

import Button from "common/core/button";
import { signIntoDigicert } from "common/account/login/digicert";
import WorkflowModalV2 from "common/modals/workflow_modal/v2";

export default function DigicertOauthModal() {
  const title = (
    <FormattedMessage
      id="02ca3b98-78ca-48db-a43c-101bb2121682"
      defaultMessage="DigiCert Session Expired"
    />
  );
  const buttons = [
    <Button onClick={signIntoDigicert} key={0} variant="secondary" buttonColor="action">
      <FormattedMessage id="7e610b70-e9d3-4386-b2a1-cb56dc26719d" defaultMessage="Continue" />
    </Button>,
  ];

  return (
    <WorkflowModalV2 title={title} buttons={buttons}>
      <FormattedMessage
        id="ef68a754-e9a7-419f-8d44-1df31984ab12"
        defaultMessage="Please reauthenticate with DigiCert."
      />
    </WorkflowModalV2>
  );
}
